import { Component, Input, Output, EventEmitter, ViewChildren, ElementRef } from "@angular/core";
import { FormBuilder, FormGroup, FormControlName, Validators } from "@angular/forms";

import { NotesService } from "./services/notes.service";
import { ToastrService } from "ngx-toastr";
import { ValidationMessages, ValidationRules } from "../../models/validationMessage";
import { GenericFormValidator } from "../../validators/genericFormArray.validator";
import { Observable, fromEvent, merge } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { INote } from "./model/INote";


@Component({
  selector: 'note-edit',
  templateUrl: "./note-edit.component.html",
})
export class NoteEditComponent {
  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];

  @Input()
  group: number = 0;

  @Input()
  section: string = "";

  @Input()
  noteId: number = -1;

  @Input()
  title: string = "";

  @Input()
  titleReadOnly: boolean = false;

  @Input()
  content: string = "";

  @Input()
  activityComplete: boolean = false;

  @Output()
  noteSaved: EventEmitter<boolean> = new EventEmitter<boolean>();

  noteForm: FormGroup;

  isSaving: boolean = false;
  failMsg: boolean = false;
  errorMessage: string = "";

  note: INote;

  initialRound: boolean = true;

  groupNumber: number = 0;

  // Use with the generic validation message class   
  displayMessage = new ValidationMessages();
  private genericValidator: GenericFormValidator;
  private validationRules = new ValidationRules();

  editorStyle = {
    height: "200px"
  }

  quillConfig = {
    toolbar: {
      container: [
        ["bold", "italic", "underline", "strike"],        // toggled buttons               
        [{ 'list': "ordered" }, { 'list': "bullet" }],
        [{ 'script': "sub" }, { 'script': "super" }],      // superscript/subscript
        [{ 'indent': "-1" }, { 'indent': "+1" }],          // outdent/indent        
      ],
    }
  }



  constructor(private notesService: NotesService,
    private toastr: ToastrService, private fb: FormBuilder) {
    this.validationRules.Messages = {
      title: {
        required: "Please include a Title to the note"
      },
      content: {
        required: "Make sure to add text for your note"
      }

    }
    this.genericValidator = new GenericFormValidator(this.validationRules);
  }

  ngOnInit() {    

    this.groupNumber = this.group + 1;
    this.section = this.groupNumber + this.section;

    this.noteForm = this.fb.group({
      id: [],
      title: ['', Validators.required],
      content: ['', Validators.required],
      programId: []
    });

    //load note
    this.loadNote();
  }

  ngAfterViewInit(): void {
    // Watch for the blur event from any input element on the form.
    let controlBlurs: Observable<any>[] = this.formInputElements
      .map((formControl: ElementRef) => fromEvent(formControl.nativeElement, 'blur'));

    // Merge the blur event observable with the valueChanges observable    
    merge(this.noteForm.valueChanges, ...controlBlurs).pipe(
      debounceTime(500)
    ).subscribe(value => {
      this.displayMessage = this.genericValidator.processMessages(this.noteForm);
      this.loadNote();
    });

  }

  loadNote() {

    this.notesService.GetUserNoteByStep(this.section)
      .subscribe(note => {
        this.note = note;

        if (this.initialRound) {
          if (this.note == null) { // no note previously added
            this.noteForm.patchValue({ title: this.title, content: this.content });
            this.noteId = -1;
          } else { // show the previously added note data
            this.noteForm.patchValue({ title: this.note.title, content: this.note.content });
            this.noteId = this.note.id;
          }

          this.initialRound = false;
        }

        this.saveNote();
      });

  }

  saveNote() {

    this.isSaving = true;
    this.errorMessage = '';

    if (this.noteForm.valid) {

      const curntNote = Object.assign({} as INote, this.noteForm.value);

      if (this.note == null) {

        this.note = curntNote;
        this.note.id = 0;
        this.note.programId = 1;
        this.note.program = "E101";
        this.note.step = this.section;

      } else {

        this.note.title = curntNote.title;
        this.note.content = curntNote.content;

      }

      this.notesService.saveNotes(this.note)
        .subscribe({
          next: () => {

            this.isSaving = false;

            //if the note is not only whitespaces emit note saved
            if (curntNote.content.replace(/\s/g, "") != '' && this.content != curntNote.content) {
              this.noteSaved.emit(true);
            }

          },
          error: err => { this.errorMessage = "An error occured while updating the note."; this.failMsg = true; }
        });

    } else {
      this.errorMessage = 'Error! The content of the note cannot be blank!';
    }
  }
}
